// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__X1jbB","content":"Consent_content__3X8aZ","footer":"Consent_footer__oK_RR"};